<div class="form-group">
  <label for="org_id">Organization</label>
  <select [(ngModel)]="orgId" (ngModelChange)="onOrgIdChange($event)" class="form-control ng-pristine ng-valid ng-touched" name="org_id" #org_id="ngModel" required>
    <option *ngFor="let org of organizations" [value]="org.id">
      {{org.name}}
    </option>
  </select>
</div>
<div class="form-group">
  <label for="location_id">Location</label>
  <select [(ngModel)]="locationId" (ngModelChange)="onLocationIdChange($event)" class="form-control ng-pristine ng-valid ng-touched" name="location_id" #location_id="ngModel" required>
    <option *ngFor="let location of locationList" [value]="location.id">
      {{location.company}}
    </option>
  </select>
</div>
